module.exports = function() {
  return new Worker("/" + "stylus-transpiler.c08f6175.worker.js");
};